import {PosCustomerViewAttachmentContainerModel} from '../../../../../../models/aggregates/erp/pos/pos-customer-view-attachment-container.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { ApiResponseModel, BasicApiResponseModel } from '../../shared/api-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PosCustomerViewAttachmentService extends BaseApiTemplateService<PosCustomerViewAttachmentContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX  +  'pos/customer-view-attachments/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'pos/customer-view-attachments/backoffice-ep';
    this.httpClient = http;
  }

  replaceFile(guid: any,dtoObject: FormData, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path+"/replace-file/"+guid;
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
